import { forwardRef } from 'react';

import { Typography, TypographyElement, TypographyProps } from '../Typography/index.js';

import { useFieldContext } from './useFieldContext.js';

export type FieldLabelElement = TypographyElement;

export interface FieldLabelProps extends TypographyProps {}

/**
 * Is a component intended to be used as a label for a form field.
 */
export const FieldLabel = forwardRef<FieldLabelElement, FieldLabelProps>(
  ({ color, size: sizeProp, variant = 'title', children, ...restProps }, ref) => {
    const { label = children, disabled, error, size } = useFieldContext();
    return (
      <Typography
        ref={ref}
        {...restProps}
        color={disabled ? 'neutral' : error ? 'error' : color}
        size={sizeProp ?? size}
        variant={variant}
      >
        {label}
      </Typography>
    );
  }
);
